import { createAction, handleActions } from 'redux-actions';
import { createRequestActionTypes } from '../../lib/createRequestSaga';
import { takeLatest, call, put } from 'redux-saga/effects';
import { startLoading, finishLoading } from '../loading';

import * as inventoryApi from '../../lib/api/inventory';


const [LIST_INV_HISTORY, LIST_INV_HISTORY_SUCCESS, LIST_INV_HISTORY_FAILURE] =
    createRequestActionTypes('inventory/LIST_INV_HISTORY');

// payload: { whUuid, ...searchParams }
export const listInventoryHistory = createAction(
    LIST_INV_HISTORY,
    (payload) => payload,
);

function* listInventoryHistorySaga(action) {
    yield put(startLoading(LIST_INV_HISTORY));
    try {
        const { whUuid, ...searchParams } = action.payload || {};
        const whId = whUuid || inventoryApi.whUuid; // fallback to default
        const response = yield call(inventoryApi.getInventoryHistory, whId, searchParams);
        yield put({
            type: LIST_INV_HISTORY_SUCCESS,
            payload: response.data,
        });
    } catch (e) {
        console.log(e, LIST_INV_HISTORY);
        yield put({
            type: LIST_INV_HISTORY_FAILURE,
            payload: e,
            error: true,
        });
    }
    yield put(finishLoading(LIST_INV_HISTORY));
}

const UNLOAD_INV_HISTORY = 'inventory/UNLOAD_INV_HISTORY';
export const unloadInventoryHistory = createAction(UNLOAD_INV_HISTORY);

export function* invHistorySaga() {
    yield takeLatest(LIST_INV_HISTORY, listInventoryHistorySaga);
}

const initialState = {
    history: null,
    error: null,
};

const invHistory = handleActions(
    {

        [LIST_INV_HISTORY_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            history: data.list.map((trn) => ({
                id: trn.trnUuid,
                trnUuid: trn.trnUuid,
                trnTyp: trn.trnTyp,
                trnNm: trn.trnNm,
                trnFromWh: trn.trnFromWh,
                trnToWh: trn.trnToWh,
                trnDesc: trn.trnDesc,
                crtUsr: trn.crtUsr,
                crtNm: trn.crtNm,
                crtDt: trn.crtDt,
            })),
            error: null,
        }),
        [LIST_INV_HISTORY_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
        [UNLOAD_INV_HISTORY]: () => initialState
    },
    initialState,
);

export default invHistory;
